export enum USER_CREATION_OPTION {
  UPDATE_USER_INFORMATION = 'updateUserInformation',
  UPDATE_USER_ROLES = 'updateUserRoles',
}
